module.exports = __webpack_public_path__ + "static/media/login-logo.a3e613a2.png";